/* eslint-disable key-spacing */
export const defaultDropDownTheme = {
  wrapper:                 'dropdown-wrapper',
  wrapperRight:            'pos-right',
  wrapperTop:              'pos-top',
  wrapperVisible:          'visible',
};
/* eslint-enable key-spacing */
